import { z } from "zod";

export const evaluationSchema = z.object({
  id: z.string(),
  content: z.string(),
  weight: z.coerce.number().min(0).max(1),
});

export type Evaluation = z.infer<typeof evaluationSchema>;
